/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "close_button_label": [{
    "type": 0,
    "value": "Close"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var DefaultTranslationComp = Object.assign(TranslationProviderComponent, {
  translations
});

export { DefaultTranslationComp as D };
//# sourceMappingURL=en-US-Bdd3DKjH.js.map
